module.exports = __webpack_public_path__ + "static/assets/c0bd3a9576802aee5c45bbddd11dec9b.gif";